module.exports = __webpack_public_path__ + "img/hourglass.17353694.svg";